import View from './view';
export const LinkedAccountsListItem = View;
